<template>


  <div class="actionbar">
    <div class="actionbar__controls">
    <v-btn
      class="abtn abtn--percent"
      :class="{ 'abtn--active': prozent }"
      density="compact"
      size="small"
      @click="prozent = !prozent"
    >
      %
    </v-btn>
    <v-btn class="abtn" :class="{ 'abtn--active': activeDateRange === 12 }" density="compact" size="small" @click="filterDates(12)">1Y</v-btn>
    <v-btn class="abtn" :class="{ 'abtn--active': activeDateRange === 36 }" density="compact" size="small" @click="filterDates(36)">3Y</v-btn>

    <v-btn class="abtn" :class="{ 'abtn--active': !prozent }" density="compact" size="small" @click="prozent = !prozent">€uro</v-btn>

    <v-btn class="abtn" density="compact" size="small" icon="mdi-skip-previous" @click="prevstock" />
    <v-btn class="abtn" density="compact" size="small" icon="mdi-skip-next" @click="nextstock" />

    <v-btn
      class="abtn abtn--mode"
      :class="{ 'abtn--active': isDailyMode }"
      density="compact"
      size="small"
      @click="loadDailyLastMonth(92)"
    >
      DAY
    </v-btn>

    <v-btn
      class="abtn abtn--mode"
      :class="{ 'abtn--active': !isDailyMode }"
      density="compact"
      size="small"
      @click="loadMonthly()"
    >
      MONTH
    </v-btn>

    </div>

    <v-toolbar class="actionbar__toolbar" color="rgba(0, 0, 0, 0)" theme="dark">
      <template #prepend>
        <v-avatar>
          <v-img
            alt="Avatar"
            :src='"/userdir/stocksymbols/symbol_" + idstock + ".png"'
          />
        </v-avatar>
      </template>

      <v-toolbar-title
        class="text-h6 analyzer-stock-title"
      >
        <span
          :class="{ 'analyzer-stock-title--clickable': canOpenStockInStocksScreen }"
          @click="openCurrentStockInStocksScreen"
        >{{ stocks_name + " - " + (nextuser?.user_username ?? "") }}</span>
      </v-toolbar-title>

      <v-combobox
        v-model="selectedStocks"
        @update:modelValue="onChangeCombo3"
        :items="stocks"
        item-title="stocks_name"
        item-value="idstocks"
        :item-props="itemProps"
        label="Select a favorite activity or create a new one"
        return-object
        multiple
      />

    </v-toolbar>

  </div>



  <div class="layout-wrapper">
    <!-- Chart links -->
    <div class="chart-wrapper">
      <v-card class="pa-2 main-chart-card" :class="{ 'main-chart-card--expanded': mainChartExpanded }">
        <div class="main-chart-box">
          <canvas
            ref="lineChart"
            class="main-chart-canvas"
          ></canvas>
        </div>
      </v-card>

      <div v-if="showStrategyCharts" class="mt-6 strategy-column">
        <div v-if="deltaAnalyses.length">
          <v-card
            v-for="analysis in deltaAnalyses"
            :key="analysis.stock_id || analysis.stock_name"
            class="mb-4 pa-4 strategy-analysis-card"
            variant="outlined"
          >
            <div class="d-flex flex-wrap align-center justify-space-between ga-3 mb-2">
              <div>
                <div class="text-h6">
                  Netto Ergebnis:
                  <span :class="deltaCurrencyClass(getDisplayedRealisiertGesamt(analysis))">
                    {{ formatDeltaCurrency(getDisplayedRealisiertGesamt(analysis)) }}
                  </span>
                </div>
                <div class="text-caption">
                  {{deltaPerformanceSentence(analysis) }}

                </div>
                <div class="text-caption">
                  {{ deltaCapitalBasisSentence(analysis) }}
                </div>
              </div>
              <v-chip :color="deltaVerdictColor(analysis)" size="small" variant="flat">
                {{ deltaVerdictLabel(analysis) }}
              </v-chip>
            </div>

            <div class="strategy-chart-box mb-3">
              <canvas :ref="el => setStrategyChartRef(el, analysis.stock_id || analysis.stock_name)"></canvas>
            </div>

            <div class="strategy-chart-box strategy-chart-box--pl mb-4">
              <canvas :ref="el => setProfitLossChartRef(el, analysis.stock_id || analysis.stock_name)"></canvas>
            </div>

            <div class="strategy-chart-box strategy-chart-box--pl mb-4">
              <canvas :ref="el => setNetResultChartRef(el, analysis.stock_id || analysis.stock_name)"></canvas>
            </div>

            <p class="mb-2">{{ deltaSummarySentence(analysis) }}</p>
            <p class="mb-2">{{ deltaPerformanceSentence(analysis) }}</p>
            <p class="mb-2">{{ deltaCapitalBasisSentence(analysis) }}</p>
            <p v-if="deltaContextSentence(analysis)" class="mb-3">{{ deltaContextSentence(analysis) }}</p>

            <div
              v-if="Array.isArray(analysis.data_quality_notes) && analysis.data_quality_notes.length"
              class="text-body-2 mb-3"
            >
              Datenhinweise: {{ analysis.data_quality_notes.slice(0, 2).join(" ") }}
            </div>

            <v-expansion-panels variant="accordion">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  <div class="raw-data-panel-title">
                    <span>Rohdaten anzeigen</span>
                    <v-btn
                      class="raw-data-copy-btn"
                      density="compact"
                      size="small"
                      variant="tonal"
                      prepend-icon="mdi-content-copy"
                      @click.stop="copyDeltaRawData(analysis)"
                    >
                      {{ copiedRawDataKey === getDeltaAnalysisKey(analysis) ? "Kopiert" : "Kopieren" }}
                    </v-btn>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <pre class="delta-json">{{ formatDeltaJson(analysis) }}</pre>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </div>

        <div v-else>Keine Bewertungsdaten geladen.</div>
      </div>
    </div>

    <!-- Headlines rechts -->
    <div v-if="stammdaten" class="headline-column">
      <v-card class="pa-2 headline-card">
        nur letzte 2 Monate V08
        <v-list density="compact">
          <v-list-item
            v-for="(item, index) in filteredArticlesLast2Months.slice(0, 8)"
            :key="index"
            @click="openFile(item.articles_URL)"
            class="cursor-pointer"
          >
            <v-list-item-title class="headline-wrap text-start">
              {{ item.articles_headline.slice(0, 100) }}{{ item.articles_headline.length > 150 ? "…" : "" }}
            </v-list-item-title>

            <v-list-item-subtitle>
              {{ new Date(item.articles_datum).toLocaleDateString() }}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
  </div>

  <div v-if="stammdaten">
    <v-list>
      <v-list-item
        v-for="(item, idx) in articles"
        :key="idx"
        class="py-3"
      >
        <template #prepend>
          <v-avatar tile size="80" color="grey" />
        </template>

        <div class="overline mb-2">
          {{ new Date(item.articles_datum).toLocaleString() }}
        </div>

        <v-list-item-title class="headline mb-1">
          {{ item.articles_stockname }}
        </v-list-item-title>

        <v-list-item-subtitle class="mb-2">
          delta %
        </v-list-item-subtitle>

        <div class="text-body-2">
          {{ item.articles_headline }}
        </div>

        <div class="text-body-2 mt-2">
          {{ item.articles_langtext }}
        </div>

        <div class="mt-3">
          <v-btn variant="outlined" @click="openFile(item.articles_URL)">
            zum kompletten Artikel
          </v-btn>
        </div>
      </v-list-item>
    </v-list>

    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="700px">
      <v-card class="mx-auto pa-4">
        <div class="text-h6 mb-2">Dividende oder Steuer (gewinn immer Plus)</div>
        <div class="text-body-2 mb-4">Brauch ich aendeungskennzeichen 4 gibt es Minus bei Steuer ??</div>

        <v-select
          label="Typ"
          v-model="editedItem.typ"
          :items="typen"
          item-title="typ"
          item-value="wert"
        />

        <v-text-field
          v-model="editedItem.menge"
          label="Menge"
          hint="1.2"
          persistent-hint
        />

        <v-text-field
          v-model="editedItem.preis"
          label="Ver/Kauf-Preis PRO Stock oder Dividende"
          hint="(immer positiv) in Euro pro Stück"
          persistent-hint
        />

        <v-text-field
          v-model="editedItem.beschreibung"
          label="beschreibung"
        />

        <div class="d-flex ga-2 mt-4">
          <v-btn color="blue" variant="tonal" @click="close">Cancel</v-btn>
          <v-btn color="blue" variant="flat" @click="createTransaction">Save</v-btn>
        </div>

        <v-divider class="my-4" />

        <v-data-table
          :headers="headers"
          :items="transactions"
          :search="search"
          :items-per-page="40"
          density="compact"
          class="elevation-1 text-caption"
        >
          <template #item.stocks_transactions_datum="{ item }">
            <div>{{ new Date(item.stocks_transactions_datum).toLocaleDateString() }}</div>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { seriesColorsByUserId } from '@/utils/userSeriesColors';
import { Chart, registerables } from "chart.js";
import "chartjs-adapter-date-fns";
Chart.register(...registerables);
import _ from "lodash";
import { markRaw, toRaw } from "vue";

export default {
  name: "AnalyzerScreen",

  data() {
    return {
      chartInstance: null,
      chartDrawLock: Promise.resolve(),
      chartDrawToken: 0,
      requestToken: 0,
      xMin: null,
      xMax: null,
      synchronizedChartMinX: null,
      synchronizedChartMaxX: null,
      isChartRebuilding: false,

      strategyChartInstances: {},
      strategyChartRefs: {},
      profitLossChartInstances: {},
      profitLossChartRefs: {},
      netResultChartInstances: {},
      netResultChartRefs: {},
      copiedRawDataKey: null,
      rawDataCopyResetTimer: null,

      selectedStocks: [],
      prozent: false,
      activeDateRange: null,
      stammdaten: false,
      idstock: 0,
      stocks_name: "",
      nextuser: null,
      dividendeGesamt: 0,
      realisiertGesamt: 0,
      dialog: false,
      search: "",
      editedIndex: -1,
      defaultItem: {
        typ: 4,
        key: -1,
        preis: 0,
        menge: 0,
        beschreibung: "",
      },
      headers: [
        { title: "Typ", fixed: true, key: "stocks_transactions_category", align: "end" },
        { title: "Menge", align: "start", key: "stocks_menge" },
        { title: "Preis", align: "start", key: "stocks_transactions_preis" },
        { title: "Datum", align: "start", key: "stocks_transactions_datum" },
        { title: "Beschreibung", align: "start", key: "stocks_transactions_beschreibung" },
      ],
      editedItem: {
        typ: 4,
        key: -1,
        preis: 0,
        menge: 0,
        beschreibung: "",
      },
      typen: [
        { typ: "Zukauf", wert: 1 },
        { typ: "Verkauf", wert: 2 },
        { typ: "Dividende", wert: 3 },
        { typ: "Vorabpauschale (positiv eingeben)", wert: 4 },
        { typ: "neues StopLoss Limit", wert: 5 },
      ],
      isDailyMode: false,
      dailyLoadedFor: null,
      lastMonthlyListGlobal: null,
      lineChartData: {
        type: "line",
        data: {
          labels: [],
          datasets: [],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          responsiveAnimationDuration: 0,
          events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],
          parsing: {
            xAxisKey: "x",
            yAxisKey: "y",
          },
          normalized: true,
          elements: { line: { tension: 0.5 } },
          scales: {
            y: { position: "left", stacked: false },
            y1: { position: "right", stacked: false, grid: { drawOnChartArea: false } },
            x: {
              type: "time",
              adapters: {
                date: {},
              },
              time: {
                unit: "day",
                displayFormats: { day: "dd.MM.yyyy" },
                tooltipFormat: "dd.MM.yyyy",
              },
              ticks: {
                display: true,
                autoSkip: true,
                maxTicksLimit: 8,
                minRotation: 0,
                maxRotation: 0,
                padding: 8,
                maxTicksRotation: 0,
              },
            },
          },
          plugins: {
            datalabels: {
              display: false,
            },
          },
        },
      },
      listGlobal: [],
    };
  },

  created() {
    this.$store.dispatch("getSettings");
    return this.$store.dispatch("getStocks");
  },

  watch: {
    prozent() {
      const activeDateRange = this.activeDateRange;
      const min = this.chartInstance?.scales?.x?.min ?? this.xMin;
      const max = this.chartInstance?.scales?.x?.max ?? this.xMax;
      const rows = activeDateRange
        ? this.listGlobal.slice(Math.max(0, this.listGlobal.length - activeDateRange))
        : this.listGlobal;
      this.makeList(rows);
      this.activeDateRange = activeDateRange;
      // Changing the value unit must preserve the visible time range, including zoom/pan.
      if (min != null && max != null) {
        this.xMin = new Date(min);
        this.xMax = new Date(max);
        this.synchronizedChartMinX = this.xMin.getTime();
        this.synchronizedChartMaxX = this.xMax.getTime();
      }
      this.$nextTick(() => this.drawChart());
    },

    deltaAnalyses: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.renderStrategyCharts();
        });
      },
    },

    showStrategyCharts(show) {
      if (show) {
        this.$nextTick(() => {
          this.renderStrategyCharts();
        });
        return;
      }

      Object.keys(this.strategyChartInstances).forEach((key) => {
        this.destroyStrategyChart(key);
      });
      Object.keys(this.profitLossChartInstances).forEach((key) => {
        this.destroyProfitLossChart(key);
      });
      Object.keys(this.netResultChartInstances).forEach((key) => {
        this.destroyNetResultChart(key);
      });
    },
  },

  computed: {
    ...mapGetters({
      articles: "stateArticles",
      stocks: "stateStocks",
      stockhistories: "stateStockhistories",
      getSettingBySettingkey: "getSettingBySettingkey",
      preisdeltas: "statePreisdeltas",
      transactions: "stateTransactions",
    }),

    deltaAnalyses() {
      return Array.isArray(this.preisdeltas) ? this.preisdeltas : [];
    },

    selectedStockCount() {
      const selected = Array.isArray(this.selectedStocks)
        ? this.selectedStocks
            .map((stock) => Number(stock?.idstocks))
            .filter(Number.isFinite)
        : [];

      if (selected.length) return selected.length;
      if (this.stammdaten && Number.isFinite(Number(this.idstock)) && Number(this.idstock) > 0) return 1;
      return 0;
    },

    showStrategyCharts() {
      return this.selectedStockCount <= 1;
    },

    currentStockRecord() {
      const currentId = Number(this.idstock);
      if (!Number.isFinite(currentId) || currentId <= 0) return null;

      return (Array.isArray(this.stocks) ? this.stocks : []).find(
        (stock) => Number(stock?.idstocks) === currentId
      ) || null;
    },

    canOpenStockInStocksScreen() {
      return Number.isFinite(Number(this.idstock)) && Number(this.idstock) > 0;
    },

    mainChartExpanded() {
      return this.selectedStockCount > 1;
    },

    filteredArticlesLast2Months() {
      if (!Array.isArray(this.articles)) return [];
      const now = new Date();
      const twoMonthsAgo = new Date();
      twoMonthsAgo.setMonth(twoMonthsAgo.getMonth() - 2);

      return this.articles
        .filter((a) => {
          const d = new Date(a.articles_datum);
          return !isNaN(d) && d >= twoMonthsAgo && d <= now;
        })
        .sort((a, b) => new Date(b.articles_datum) - new Date(a.articles_datum));
    },
  },

  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown, true);
    if (this._onResize) window.removeEventListener("resize", this._onResize);
    if (this._raf) cancelAnimationFrame(this._raf);
    if (this.rawDataCopyResetTimer) clearTimeout(this.rawDataCopyResetTimer);

    if (this.chartInstance) {
      try {
        this.chartInstance.stop();
        this.chartInstance.destroy();
      } catch (e) {
        console.warn("chart destroy failed (beforeUnmount)", e);
      } finally {
        this.chartInstance = null;
      }
    }

    Object.values(this.strategyChartInstances || {}).forEach((chart) => {
      try {
        chart.stop();
        chart.destroy();
      } catch (e) {
        console.warn("strategy chart destroy failed", e);
      }
    });

    this.strategyChartInstances = {};
    this.strategyChartRefs = {};

    Object.values(this.profitLossChartInstances || {}).forEach((chart) => {
      try {
        chart.stop();
        chart.destroy();
      } catch (e) {
        console.warn("profit/loss chart destroy failed", e);
      }
    });

    this.profitLossChartInstances = {};
    this.profitLossChartRefs = {};

    Object.values(this.netResultChartInstances || {}).forEach((chart) => {
      try {
        chart.stop();
        chart.destroy();
      } catch (e) {
        console.warn("net result chart destroy failed", e);
      }
    });

    this.netResultChartInstances = {};
    this.netResultChartRefs = {};

  },

  mounted() {
    window.addEventListener("keydown", this.onKeydown, true);
    this.scrollAnalyzerToTop();

    this._onResize = _.throttle(() => this.scheduleResponsiveUpdate(), 150);
    window.addEventListener("resize", this._onResize, { passive: true });

    const q = this.$route.query || {};
    const qIdsRaw = String(q.ids || "").trim();
    const hasCompareIds = qIdsRaw.length > 0;

    const p = this.$route.params || {};
    const pId = p.idstocks != null ? String(p.idstocks) : "";
    const pName = p.stocks_name != null ? String(p.stocks_name) : "";

    if (q.prozent != null) {
      this.prozent =
        String(q.prozent) === "1" ||
        String(q.prozent).toLowerCase() === "true";
    }

    const requestedMode = this.normalizeRouteMode(q.mode);

    if (hasCompareIds) {
      this.stammdaten = false;
      this.idstock = 0;
      this.stocks_name = "";
      this.nextuser = null;

      this.initFromRouteQuery();

      this.scheduleResponsiveUpdate();
      return;
    }

    if (this.idstock) {
      this.stammdaten = true;
      this.isDailyMode = requestedMode === "daily";

      const idx = (this.stocks || []).findIndex(
        (s) => String(s.idstocks) === String(this.idstock)
      );
      if (idx !== -1) {
        this.nextuser = this.stocks[idx]?.user_iduser ?? null;
      } else {
        this.nextuser = null;
      }

      this.stammdatenAktualsieren();
      this.scheduleResponsiveUpdate();
      return;
    }

    this.idstock = pId ? Number(pId) : 0;
    this.stocks_name = pName || "";

    if (this.idstock) {
      this.stammdaten = true;
      this.isDailyMode = requestedMode === "daily";

      const idx = (this.stocks || []).findIndex(
        (s) => String(s.idstocks) === String(this.idstock)
      );
      if (idx !== -1) {
        this.nextuser = this.stocks[idx]?.user_iduser ?? null;
      } else {
        this.nextuser = null;
      }

      this.stammdatenAktualsieren();
      this.scheduleResponsiveUpdate();
      return;
    }

    this.stammdaten = false;
    this.idstock = 0;
    this.stocks_name = "";
    this.nextuser = null;

    const defaultIds = [111, 112, 114];
    this.$store.dispatch("getStockhistories", defaultIds).then(
      async () => {
        this.listGlobal = this.stockhistories;
        this.makeList(this.listGlobal);
        await this.drawChart();
        this.scheduleResponsiveUpdate();
      },
      (error) => console.error("Got nothing from server.", error)
    );
  },

  methods: {
    ...mapActions(["createStock"]),

    scrollAnalyzerToTop() {
      const applyScrollTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        if (document?.documentElement) document.documentElement.scrollTop = 0;
        if (document?.body) document.body.scrollTop = 0;
      };

      applyScrollTop();
      requestAnimationFrame(() => {
        applyScrollTop();
      });
    },

    openCurrentStockInStocksScreen() {
      if (!this.canOpenStockInStocksScreen) return;

      this.$router.push({
        name: "Stocks",
        query: {
          focusStockId: String(this.idstock),
        },
      });
    },


    setProfitLossChartRef(el, key) {
      if (!key) return;

      if (el) {
        this.profitLossChartRefs[key] = el;
      } else {
        delete this.profitLossChartRefs[key];
      }
    },

    setNetResultChartRef(el, key) {
      if (!key) return;

      if (el) {
        this.netResultChartRefs[key] = el;
      } else {
        delete this.netResultChartRefs[key];
      }
    },

    destroyProfitLossChart(key) {
      const existing = this.profitLossChartInstances[key];
      if (!existing) return;

      try {
        existing.stop();
        existing.destroy();
      } catch (e) {
        console.warn("destroyProfitLossChart failed", e);
      } finally {
        delete this.profitLossChartInstances[key];
      }
    },

    destroyNetResultChart(key) {
      const existing = this.netResultChartInstances[key];
      if (!existing) return;

      try {
        existing.stop();
        existing.destroy();
      } catch (e) {
        console.warn("destroyNetResultChart failed", e);
      } finally {
        delete this.netResultChartInstances[key];
      }
    },

buildProfitLossSeries(analysis) {
  const trades = Array.isArray(analysis?.trades) ? analysis.trades : [];
  if (!trades.length) return [];

  const sortedTrades = [...trades].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );

  let cumulative = 0;
  const points = [];

  const firstTrade = sortedTrades.find((t) => t?.date);
  if (firstTrade) {
    const firstTs = new Date(firstTrade.date).getTime();
    if (Number.isFinite(firstTs)) {
      points.push({
        x: firstTs - 1000,
        y: 0,
      });
    }
  }

  for (const t of sortedTrades) {
    const ts = new Date(t.date).getTime();
    if (!Number.isFinite(ts)) continue;

    const cat = String(t.category || "").toUpperCase();

    if (cat === "SELL") {
      cumulative += Number(t.realized_pnl || 0);
    }

    if (cat === "DIVIDEND" || cat === "TAX") {
      cumulative += Number(t.cash_effect || 0);
    }

    points.push({
      x: ts,
      y: Math.round(cumulative * 100) / 100,
    });
  }

  return points;
},

buildNetResultSeries(analysis) {
  const baseSeries = this.buildProfitLossSeries(analysis);
  if (!baseSeries.length) return [];

  const points = [...baseSeries];
  const target = Number(analysis?.actual_strategy?.net_result);
  if (!Number.isFinite(target)) return points;

  const lastPoint = points[points.length - 1];
  const lastX = Number(lastPoint?.x);
  const lastY = Number(lastPoint?.y);

  if (!Number.isFinite(lastX)) return points;

  const endTs = Math.max(lastX + 1, Date.now());
  if (lastY !== target) {
    points.push({
      x: endTs,
      y: Math.round(target * 100) / 100,
    });
  } else {
    points.push({
      x: endTs,
      y: Math.round(lastY * 100) / 100,
    });
  }

  return points;
},

getProfitLossTargetValue(analysis) {
  const actual = analysis?.actual_strategy || {};
  const realized = Number(actual.realized_pnl || 0);
  const other = Number(actual.non_trade_cashflows || 0);
  return Math.round((realized + other) * 100) / 100;
},
    async onChangeCombo3() {
      const myReq = ++this.requestToken;
      await this.$nextTick();
      if (myReq !== this.requestToken) return;

      const selected = Array.isArray(this.selectedStocks) ? this.selectedStocks : [];
      const selectedIds = selected
        .map((stock) => Number(stock?.idstocks))
        .filter(Number.isFinite);

      if (selectedIds.length === 1) {
        const currentStock = selected.find((stock) => Number(stock?.idstocks) === selectedIds[0]) || null;
        this.idstock = selectedIds[0];
        this.stammdaten = true;
        this.stocks_name = currentStock?.stocks_name || "";
        this.nextuser = currentStock?.user_iduser ?? null;
      } else if (selectedIds.length > 1) {
        this.stammdaten = false;
      }

      if (this.isDailyMode) {
        await this.loadDailyLastMonth(92, myReq);
      } else {
        await this.loadMonthly(myReq);
      }
    },

    async renderChartsForTab(tab) {
      await this.$nextTick();

      if (tab === "overview") {
        await this.renderPieChart();
        await this.renderBarChart();
      } else if (tab === "relperf") {
        await this.renderRelPerfChart();
      }
    },

    async initFromRouteQuery() {
      this.scrollAnalyzerToTop();
      const q = this.$route.query || {};

      if (q.prozent != null) {
        this.prozent = String(q.prozent) === "1" || String(q.prozent).toLowerCase() === "true";
      }

      const ids = String(q.ids || "")
        .split(",")
        .map(x => Number(x))
        .filter(Number.isFinite);

      if (!ids.length) return;

      if (!this.stocks?.length) {
        await this.$store.dispatch("getStocks");
      }

      this.selectedStocks = (this.stocks || []).filter(s => ids.includes(Number(s.idstocks)));
      this.stammdaten = false;

      const mode = this.normalizeRouteMode(q.mode);
      if (mode === "daily") await this.loadDailyLastMonth(92);
      else await this.loadMonthly();
      this.scrollAnalyzerToTop();
    },

    getPlainChartOptions() {
      const opt = _.cloneDeep(toRaw(this.lineChartData.options));

      const isMobile = window.innerWidth <= 600;

      opt.plugins = opt.plugins || {};
      opt.plugins.legend = opt.plugins.legend || {};
      opt.plugins.legend.labels = opt.plugins.legend.labels || {};
      opt.plugins.legend.labels.filter = (legendItem, chartData) => {
        const dataset = chartData?.datasets?.[legendItem.datasetIndex];
        return dataset?._isCurrentValueReference !== true;
      };
      opt.plugins.tooltip = opt.plugins.tooltip || {};
      opt.plugins.tooltip.filter = (tooltipItem) =>
        tooltipItem?.dataset?._isCurrentValueReference !== true;

      if (opt?.scales?.x?.ticks) {
        opt.scales.x.ticks.display = !isMobile;
      }

      if (opt?.scales?.x) {
        opt.scales.x.min = this.xMin ?? undefined;
        opt.scales.x.max = this.xMax ?? undefined;
      }

      return opt;
    },

    scheduleResponsiveUpdate() {
      if (this._raf) cancelAnimationFrame(this._raf);

      this._raf = requestAnimationFrame(() => {
        const chart = this.chartInstance;
        if (!chart || !chart.canvas) return;

        const isMobile = window.innerWidth <= 600;

        const xTicks = chart.options?.scales?.x?.ticks;
        if (!xTicks) return;

        const newVal = !isMobile;
        if (xTicks.display === newVal) return;

        xTicks.display = newVal;

        try {
          chart.update("none");
        } catch (e) {
          // ignore
        }
      });
    },

    DividendeSteuer() {
      this.dialog = true;
    },

    idsToLoad() {
      const selected = (this.selectedStocks || [])
        .map(s => Number(s.idstocks))
        .filter(Number.isFinite);

      if (selected.length) return selected;

      if (this.stammdaten && this.idstock) return [Number(this.idstock)];

      return [111, 112, 114];
    },

    parseChartDate(dateStr) {
      if (!dateStr) return null;

      const hasTZ = /Z$|[+-]\d{2}:\d{2}$/.test(dateStr);
      const iso = hasTZ ? dateStr : `${dateStr}Z`;

      const d = new Date(iso);
      if (isNaN(d)) return null;

      return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
    },

    onKeydown(e) {
      if (e.code === "ArrowRight" || e.key === "ArrowRight") {
        this.nextstock();
      }

      if (e.code === "ArrowLeft" || e.key === "ArrowLeft") {
        this.prevstock();
      }

      if (e.code === "Space" || e.key === " ") {
        e.preventDefault();
        this.nextstock();
      }
    },

    openFile(url) {
      if (!url) return;
      window.open(url, "_blank", "noopener,noreferrer");
    },

    normalizeRouteMode(mode) {
      const normalized = String(mode || "").trim().toLowerCase();
      if (normalized === "day" || normalized === "daily") return "daily";
      if (normalized === "month" || normalized === "monthly") return "monthly";
      return "monthly";
    },

    prevstock() {
      const currentIndex = this.stocks.findIndex((s) => String(s.idstocks) === String(this.idstock));
      if (currentIndex > 0) {
        const prev = this.stocks[currentIndex - 1];
        this.stocks_name = prev.stocks_name;
        this.idstock = prev.idstocks;
        this.nextuser = prev.user_iduser ?? null;
        this.stammdatenAktualsieren();
      }
    },

    async loadMonthly(myReqToken = null) {
      this.scrollAnalyzerToTop();
      const ids = this.idsToLoad();
      if (!ids.length) return;

      const req = myReqToken ?? ++this.requestToken;

      try {
        this.isDailyMode = false;
        this.dailyLoadedFor = null;

        await this.$store.dispatch("getStockhistories", ids);
        await this.$store.dispatch("getPreisdeltas", ids);

        if (req !== this.requestToken) return;

        this.listGlobal = this.stockhistories;
        this.lastMonthlyListGlobal = this.listGlobal;

        this.makeList(this.listGlobal);
        await this.drawChart();

        await this.$nextTick();
        this.renderStrategyCharts();
        this.scrollAnalyzerToTop();
      } catch (e) {
        console.error("loadMonthly failed", e);
      }
    },

    nextstock() {
      const currentIndex = this.stocks.findIndex((s) => String(s.idstocks) === String(this.idstock));
      if (currentIndex !== -1 && currentIndex < this.stocks.length - 1) {
        const next = this.stocks[currentIndex + 1];
        this.stocks_name = next.stocks_name;
        this.idstock = next.idstocks;
        this.nextuser = next.user_iduser ?? null;
        this.stammdatenAktualsieren();
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async loadDailyLastMonth(days = 92, myReqToken = null) {
      this.scrollAnalyzerToTop();
      const ids = this.idsToLoad();
      if (!ids.length) return;

      const req = myReqToken ?? ++this.requestToken;

      if (!this.lastMonthlyListGlobal) {
        this.lastMonthlyListGlobal = this.listGlobal;
      }

      try {
        const dailyRows = await this.$store.dispatch("getStockhistoriesDaily", { ids, days });

        if (req !== this.requestToken) return;

        this.isDailyMode = true;
        this.dailyLoadedFor = ids.join(",");

        this.listGlobal = dailyRows;

        this.makeList(this.listGlobal);
        await this.drawChart();

        this.applyChartRangeLastDays(days);
        this.scrollAnalyzerToTop();
      } catch (e) {
        console.error("loadDailyLastMonth failed", e);
      }
    },

    switchBackToMonthly() {
      const selectedIds = (this.selectedStocks || [])
        .map(s => Number(s.idstocks))
        .filter(Number.isFinite);

      if (selectedIds.length) {
        return this.loadMonthly();
      }

      if (!this.lastMonthlyListGlobal) return;

      this.isDailyMode = false;
      this.dailyLoadedFor = null;
      this.synchronizedChartMinX = null;
      this.synchronizedChartMaxX = null;

      this.listGlobal = this.lastMonthlyListGlobal;

      this.makeList(this.listGlobal);
      this.$nextTick(() => this.drawChart());
    },

    applyChartRangeLastDays(days = 31) {
      if (!this.chartInstance) return;

      const x = this.chartInstance.scales.x;
      if (!x) return;

      const max = x.max;
      const min = max - (1000 * 60 * 60 * 24 * days);

      this.xMin = new Date(min);
      this.xMax = new Date(max);
      this.synchronizedChartMinX = min;
      this.synchronizedChartMaxX = max;
      this.chartInstance.options.scales.x.min = min;
      this.chartInstance.options.scales.x.max = max;
      this.chartInstance.update("none");

      console.log("DAY range applied", {
        days,
        requestedRange: { minX: min, maxX: max },
        chartInstanceScale: {
          min: this.chartInstance?.scales?.x?.min ?? null,
          max: this.chartInstance?.scales?.x?.max ?? null,
        },
        chartInstanceOptions: {
          min: this.chartInstance?.options?.scales?.x?.min ?? null,
          max: this.chartInstance?.options?.scales?.x?.max ?? null,
        },
      });

      this.renderStrategyCharts({ minX: min, maxX: max });
    },

    async stammdatenAktualsieren() {
      this.scrollAnalyzerToTop();

      if (!Array.isArray(this.stocks) || !this.stocks.length) {
        try {
          await this.$store.dispatch("getStocks");
        } catch (e) {
          console.error("getStocks failed", e);
        }
      }

      const currentStock =
        (Array.isArray(this.stocks) ? this.stocks : []).find(
          (stock) => Number(stock?.idstocks) === Number(this.idstock)
        ) || null;

      if (currentStock) {
        this.stocks_name = currentStock.stocks_name || this.stocks_name;
        this.nextuser = currentStock.user_iduser ?? this.nextuser;

        const storedRealisiert = Number(currentStock.stock_Realsiert);
        if (Number.isFinite(storedRealisiert)) {
          this.realisiertGesamt = Math.round(storedRealisiert * 100) / 100;
        }
      }

      const ausgewaehlteStockIDs = [this.idstock];

      try {
        if (this.isDailyMode) {
          this.listGlobal = await this.$store.dispatch("getStockhistoriesDaily", {
            ids: ausgewaehlteStockIDs,
            days: 92,
          });
          this.dailyLoadedFor = ausgewaehlteStockIDs.join(",");
        } else {
          await this.$store.dispatch("getStockhistories", ausgewaehlteStockIDs);
          this.listGlobal = this.stockhistories;
          this.dailyLoadedFor = null;
        }

        this.makeList(this.listGlobal);

        await this.$nextTick();
        await this.drawChart();
        if (this.isDailyMode) {
          this.applyChartRangeLastDays(92);
        }
        this.scrollAnalyzerToTop();
      } catch (e) {
        console.error("getStockhistories failed", e);
      }

      this.$store.dispatch("getPreisdeltas", ausgewaehlteStockIDs)
        .then(async () => {
          await this.$nextTick();
          this.renderStrategyCharts();
        })
        .catch(e => console.error("getPreisdeltas failed", e));

      const TracForm = new FormData();
      TracForm.append("idstock", this.idstock);
      this.$store.dispatch("getArticles", TracForm).catch(e => console.error("getArticles failed", e));

      this.$store.dispatch("getTransactions", this.idstock).then(() => {
        console.log("this.transactions", this.transactions);
        const txRealisiert = _.sumBy(
          (Array.isArray(this.transactions) ? this.transactions : []).filter((t) => {
            const category = Number(t?.stocks_transactions_category);
            const preis = Number(t?.stocks_transactions_preis);

            return (category === 2 || category === 3) && Number.isFinite(preis);
          }),
          (t) => Number(t?.stocks_transactions_preis || 0)
        );

        const storedRealisiert = Number(
          currentStock?.stock_Realsiert ?? this.currentStockRecord?.stock_Realsiert
        );
        this.realisiertGesamt = Number.isFinite(storedRealisiert)
          ? storedRealisiert
          : txRealisiert;
        this.realisiertGesamt = Math.round(this.realisiertGesamt * 100) / 100;
      }).catch(e => console.error("getTransactions failed", e));
    },

    async createTransaction() {
      const TracForm = new FormData();
      TracForm.append("idstocks", this.idstock);
      TracForm.append("aenderungskennzeichen", this.editedItem.typ);
      TracForm.append("preis", this.editedItem.preis);

      this.$store.dispatch("createTransaction", TracForm).then(
        () => {
          this.dialog = false;
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
          }, 300);
        },
        (error) => console.error("createTransaction failed", error)
      );
    },

    itemProps(item) {
      return {
        title: item.stocks_name,
        subtitle: item.user_iduser?.user_username ?? "",
      };
    },

    formatDeltaCurrency(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "n/a";
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        maximumFractionDigits: 2,
      }).format(num);
    },

    deltaCurrencyClass(value) {
      return Number(value) < 0 ? "text-error" : "text-success";
    },

    formatDeltaPercent(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return "n/a";
      return `${num.toFixed(2)} %`;
    },

    formatDeltaDate(value) {
      if (!value) return "unbekannt";
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return "unbekannt";
      return d.toLocaleDateString("de-DE");
    },

    formatDeltaJson(value) {
      return JSON.stringify(value, null, 2);
    },

    getDeltaAnalysisKey(analysis) {
      return String(analysis?.stock_id || analysis?.stock_name || "");
    },

    async copyDeltaRawData(analysis) {
      const text = this.formatDeltaJson(analysis);

      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      this.copiedRawDataKey = this.getDeltaAnalysisKey(analysis);
      if (this.rawDataCopyResetTimer) clearTimeout(this.rawDataCopyResetTimer);
      this.rawDataCopyResetTimer = setTimeout(() => {
        this.copiedRawDataKey = null;
        this.rawDataCopyResetTimer = null;
      }, 1800);
    },

    deltaVerdictColor(analysis) {
      const winner = String(analysis?.better_strategy || "");
      if (winner === "actual_strategy") return "success";
      if (winner === "buy_and_hold_benchmark") return "warning";
      return "info";
    },

    deltaVerdictLabel(analysis) {
      const winner = String(analysis?.better_strategy || "");
      if (winner === "actual_strategy") return "Aktive Strategie besser";
      if (winner === "buy_and_hold_benchmark") return "Buy and Hold besser";
      return "Keine klare Aussage";
    },

    deltaSummarySentence(analysis) {
      const stock = analysis?.stock_name || "Dieser Wert";
      const winner = String(analysis?.better_strategy || "");
      const outperformance = this.formatDeltaCurrency(Math.abs(Number(analysis?.outperformance_eur || 0)));

      if (winner === "actual_strategy") {
        return `${stock}: Deine echten Käufe und Verkäufe waren besser als einfaches Halten. Der Vorsprung liegt aktuell bei ${outperformance}.`;
      }
      if (winner === "buy_and_hold_benchmark") {
        return `${stock}: Reines Halten wäre besser gewesen. Die aktive Strategie liegt aktuell um ${outperformance} zurück.`;
      }
      return `${stock}: Zwischen aktiver Strategie und Buy-and-Hold gibt es aktuell keinen klaren Sieger.`;
    },

    deltaPerformanceSentence(analysis) {
      const actual = analysis?.actual_strategy || {};
      const benchmark = analysis?.buy_and_hold_benchmark || {};
      return `Aktive Strategie: ${this.formatDeltaCurrency(actual.net_result)} (${this.formatDeltaPercent(actual.return_pct_on_invested_capital)} Rendite auf Kapitalbedarf). Buy-and-Hold: ${this.formatDeltaCurrency(benchmark.net_result)} (${this.formatDeltaPercent(benchmark.return_pct_on_invested_capital)} Rendite auf dasselbe Budget).`;
    },

    deltaCapitalBasisSentence(analysis) {
      const actual = analysis?.actual_strategy || {};
      const benchmark = analysis?.buy_and_hold_benchmark || {};
      const externalCapital = Number(
        analysis?.external_capital_required ?? actual.invested_capital
      );
      const benchmarkCapital = Number(benchmark.invested_capital);
      const grossBuys = Number(actual.gross_buy_principal);

      const parts = [];
      if (Number.isFinite(externalCapital)) {
        parts.push(`Kapitalbedarf aktiv: ${this.formatDeltaCurrency(externalCapital)}`);
      }
      if (Number.isFinite(benchmarkCapital)) {
        parts.push(`Buy-and-Hold-Budget: ${this.formatDeltaCurrency(benchmarkCapital)}`);
      }
      if (Number.isFinite(grossBuys)) {
        parts.push(`Brutto-Käufe aktiv: ${this.formatDeltaCurrency(grossBuys)}`);
      }

      return parts.length
        ? `${parts.join(". ")}. Spätere Käufe erhöhen Buy-and-Hold nur bei neu benötigtem externem Kapital.`
        : "Renditen werden auf das extern benötigte Kapital der aktiven Strategie bezogen.";
    },

    getDisplayedRealisiertGesamt(analysis) {
      const netResult = Number(analysis?.actual_strategy?.net_result);
      if (Number.isFinite(netResult)) return netResult;

      const target = Number(this.getProfitLossTargetValue(analysis));
      if (Number.isFinite(target)) return target;

      return Number(this.realisiertGesamt || 0);
    },

    deltaContextSentence(analysis) {
      const parts = [];
      const tradeCount = Number(analysis?.trade_count);
      const quality = String(analysis?.result_quality || "");

      if (Number.isFinite(tradeCount)) {
        parts.push(`${tradeCount} Transaktionen berücksichtigt`);
      }
      if (quality) {
        parts.push(`Datenqualität ${quality}`);
      }
      if (analysis?.analysis_start_date) {
        parts.push(`Analyse ab ${this.formatDeltaDate(analysis.analysis_start_date)}`);
      }

      return parts.length ? `${parts.join(", ")}.` : "";
    },

    filterDates(Tage) {
      if (!this.listGlobal?.length) return;

      let filteredlist = this.listGlobal;
      if (Tage !== 0) {
        filteredlist = this.listGlobal.slice(Math.max(0, this.listGlobal.length - Tage));
      }

      this.makeList(filteredlist);
      this.activeDateRange = Tage;
      this.drawChart();
    },

    DrawOneYear() {
      const ausgewaehlteStockIDs = [];
      this.selectedStocks.forEach((x) => ausgewaehlteStockIDs.push(x.idstocks));

      this.$store.dispatch("getStockhistories", ausgewaehlteStockIDs).then(
        () => {
          this.listGlobal = this.stockhistories;
          this.makeList(this.listGlobal);
          this.drawChart();
        },
        (error) => console.error("getStockhistories failed", error)
      );
    },

    async drawChart() {
      const myToken = ++this.chartDrawToken;

      this.chartDrawLock = this.chartDrawLock.then(async () => {
        if (myToken !== this.chartDrawToken) return;

        this.isChartRebuilding = true;
        try {
          await this.$nextTick();

          const canvasEl = this.$refs.lineChart;
          if (!canvasEl || !canvasEl.getContext) return;

          const existing = Chart.getChart(canvasEl);
          if (existing) {
            try {
              existing.stop();
              existing.destroy();
            } catch (e) {
              console.warn("existing chart destroy failed", e);
            }
          }

          if (this.chartInstance) {
            const old = this.chartInstance;
            this.chartInstance = null;
            try {
              old.stop();
              old.destroy();
            } catch (e) {
              console.warn("chart destroy failed (drawChart)", e);
            }
          }

          if (myToken !== this.chartDrawToken) return;

          const ctx = canvasEl.getContext("2d");
          if (!ctx) return;

          const opt = this.getPlainChartOptions();
          opt.interaction = opt.interaction ?? { mode: "nearest", intersect: false };
          opt.hover = opt.hover ?? { mode: "nearest", intersect: false };

          this.chartInstance = markRaw(new Chart(ctx, {
            type: this.lineChartData.type,
            data: toRaw(this.lineChartData.data),
            options: opt,
          }));

          this.logChartTimeDebug("main", "main", this.chartInstance, opt?.scales?.x ?? null, {
            datasets: Array.isArray(this.lineChartData?.data?.datasets)
              ? this.lineChartData.data.datasets.length
              : 0,
          });

          this.scheduleResponsiveUpdate();
        } finally {
          if (myToken === this.chartDrawToken) this.isChartRebuilding = false;
        }
      });

      return this.chartDrawLock;
    },

    makeList(filteredListGlobal) {
      this.activeDateRange = null;
      this.lineChartData.data.labels = [];
      this.lineChartData.data.datasets = [];

      if (!Array.isArray(filteredListGlobal) || filteredListGlobal.length === 0) {
        this.xMin = null;
        this.xMax = null;
        return;
      }

      const rows = [...filteredListGlobal].sort(
        (a, b) => new Date(a.datum) - new Date(b.datum)
      );

      const keys = Object.keys(rows[0]).filter((key) => key !== "datum");

      const stockKeys = keys.filter((key) => key !== "trend" && !/^MA\d+$/i.test(key));
      const isSingleStockMode = stockKeys.length === 1;

      let orderedKeys;
      if (isSingleStockMode) {
        const mainStockKey = stockKeys[0];
        orderedKeys = [
          mainStockKey,
          "MA20",
          "MA200",
          "MA50",
          "trend",
        ].filter((wantedKey) => keys.includes(wantedKey));
      } else {
        orderedKeys = [...keys].sort((a, b) => a.localeCompare(b));
      }

      const singleStockStyle = {
        stock: { color: "#e6efea", width: 2.5 },
        MA20: { color: "#b8c69a", width: 1 },
        MA50: { color: "#3f67f0", width: 1.5 },
        MA200: { color: "#e23b8b", width: 1.5 },
        trend: { color: "#d1437c", width: 1, dash: [8, 6] },
      };

      const multiStockSeriesColorMap = {
        "0_cRohstoff": "#f59e0b",
        "0_cETF": "#22c55e",
        "0_cAktie": "#3b82f6",
        trend: "#ec4899",
      };

      // History keys contain the current username; derive their colors from the owner's stable ID.
      for (const stock of this.stocks || []) {
        const user = stock.user_iduser;
        const color = seriesColorsByUserId[Number(user?.iduser)]?.[stock.stocks_name];
        if (color && user?.user_username) {
          multiStockSeriesColorMap[`${stock.stocks_name}_${user.user_username}`] = color;
        }
      }

      const fallbackColors = [
        "#ef4444",
        "#14b8a6",
        "#a855f7",
        "#eab308",
        "#06b6d4",
        "#f97316",
        "#84cc16",
        "#fb7185",
        "#0ea5e9",
        "#d946ef",
        "#10b981",
        "#f43f5e",
        "#6366f1",
        "#ca8a04",
        "#0891b2",
        "#9333ea",
      ];
      let fallbackIndex = 0;

      const getSeriesColor = (key) => {
        if (multiStockSeriesColorMap[key]) return multiStockSeriesColorMap[key];

        const normalizedKey = String(key || "").toLowerCase();
        if (normalizedKey.includes("0_cvirtuell")) return "#f8fafc";
        if (normalizedKey.includes("0_depotkursaktuell")) return "#38bdf8";
        if (normalizedKey.includes("0_ufosdepotkursaktuell")) return "#f472b6";
        if (normalizedKey.includes("0_crohstoff")) return "#f59e0b";
        if (normalizedKey.includes("0_cetf")) return "#22c55e";
        if (normalizedKey.includes("0_caktie")) return "#3b82f6";

        return null;
      };

      for (const key of orderedKeys) {
        const isTrend = key === "trend";
        const isMA = /^MA\d+$/i.test(key);
        const isStock = !isTrend && !isMA;

        let color = "#cccccc";
        let borderWidth = 2;
        let borderDash = [];

        if (isSingleStockMode) {
          if (isStock) {
            color = singleStockStyle.stock.color;
            borderWidth = singleStockStyle.stock.width;
          } else if (/^MA20$/i.test(key)) {
            color = singleStockStyle.MA20.color;
            borderWidth = singleStockStyle.MA20.width;
          } else if (/^MA50$/i.test(key)) {
            color = singleStockStyle.MA50.color;
            borderWidth = singleStockStyle.MA50.width;
          } else if (/^MA200$/i.test(key)) {
            color = singleStockStyle.MA200.color;
            borderWidth = singleStockStyle.MA200.width;
          } else if (isTrend) {
            color = singleStockStyle.trend.color;
            borderWidth = singleStockStyle.trend.width;
            borderDash = singleStockStyle.trend.dash || [];
          } else {
            color = fallbackColors[fallbackIndex % fallbackColors.length];
          }
        } else {
          if (isTrend) {
            color = multiStockSeriesColorMap.trend;
            borderWidth = 2;
            borderDash = [8, 6];
          } else if (getSeriesColor(key)) {
            color = getSeriesColor(key);
            borderWidth = isStock ? 3 : 1.5;
          } else {
            color = fallbackColors[fallbackIndex % fallbackColors.length];
            borderWidth = isStock ? 3 : 1.5;
          }
        }

        const datasetDynRow = {
          label: key,
          data: [],
          pointRadius: 0,
          tension: 0.5,
          borderWidth,
          borderDash,
          borderColor: color,
          backgroundColor: color,
          fill: false,
          yAxisID: isTrend ? "y1" : "y",
        };

        const points = rows.map((row) => {
          const value = row[key];
          return {
            x: this.parseChartDate(row.datum),
            y: value === null || value === undefined || value === '' ? NaN : Number(value),
          };
        }).filter((point) => point.x && Number.isFinite(point.y))
          .sort((a, b) => a.x.getTime() - b.x.getTime());

        if (!isTrend && this.prozent === true) {
          // Normalize against the first point actually plotted, not an unplottable history row.
          const baseIndex = points.findIndex((point) => point.y !== 0);
          datasetDynRow.data = baseIndex < 0 ? [] : points.slice(baseIndex).map((point) => ({
            x: point.x,
            y: (point.y / points[baseIndex].y) * 100,
          }));
        } else {
          datasetDynRow.data = points;
        }

        if (datasetDynRow.data.length > 0) {
          this.lineChartData.data.datasets.push(datasetDynRow);

          const usedNamedColor =
            isSingleStockMode
              ? (
                  isStock ||
                  /^MA20$/i.test(key) ||
                  /^MA50$/i.test(key) ||
                  /^MA200$/i.test(key) ||
                  isTrend
                )
              : (
                  isTrend || !!getSeriesColor(key)
                );

          if (!usedNamedColor) {
            fallbackIndex += 1;
          }
        }
      }

      const allX = this.lineChartData.data.datasets
        .flatMap((ds) => (Array.isArray(ds.data) ? ds.data : []))
        .map((p) => p?.x)
        .filter((d) => d instanceof Date && !isNaN(d));

      if (allX.length) {
        const minTime = Math.min(...allX.map((d) => d.getTime()));
        const maxTime = Math.max(...allX.map((d) => d.getTime()));

        this.xMin = new Date(minTime);
        this.xMax = new Date(maxTime);
        this.synchronizedChartMinX = minTime;
        this.synchronizedChartMaxX = maxTime;

        if (this.shouldShowCurrentValueReferenceLines()) {
          this.addCurrentValueReferenceLines(minTime, maxTime);
        }
      } else {
        this.xMin = null;
        this.xMax = null;
        this.synchronizedChartMinX = null;
        this.synchronizedChartMaxX = null;
      }
    },

    shouldShowCurrentValueReferenceLines() {
      const q = this.$route?.query || {};
      return String(q.currentValueLines || "") === "1";
    },

    addCurrentValueReferenceLines(minTime, maxTime) {
      if (!Number.isFinite(minTime) || !Number.isFinite(maxTime)) return;

      const sourceDatasets = (this.lineChartData.data.datasets || []).filter(
        (dataset) =>
          dataset?._isCurrentValueReference !== true &&
          dataset?.yAxisID !== "y1" &&
          Array.isArray(dataset?.data) &&
          dataset.data.length > 0
      );

      const referenceLines = sourceDatasets
        .map((dataset) => {
          const lastPoint = [...dataset.data]
            .reverse()
            .find((point) => Number.isFinite(Number(point?.y)));

          const y = Number(lastPoint?.y);
          if (!Number.isFinite(y)) return null;

          return {
            label: `${dataset.label} aktueller Wert`,
            data: [
              { x: new Date(minTime), y },
              { x: new Date(maxTime), y },
            ],
            pointRadius: 0,
            pointHoverRadius: 0,
            tension: 0,
            borderWidth: 1,
            borderDash: [4, 4],
            borderColor: dataset.borderColor || "#9ca3af",
            backgroundColor: dataset.borderColor || "#9ca3af",
            fill: false,
            yAxisID: dataset.yAxisID || "y",
            _isCurrentValueReference: true,
          };
        })
        .filter(Boolean);

      this.lineChartData.data.datasets.push(...referenceLines);
    },

    setStrategyChartRef(el, key) {
      if (!key) return;

      if (el) {
        this.strategyChartRefs[key] = el;
      } else {
        delete this.strategyChartRefs[key];
      }
    },

    destroyStrategyChart(key) {
      const existing = this.strategyChartInstances[key];
      if (!existing) return;

      try {
        existing.stop();
        existing.destroy();
      } catch (e) {
        console.warn("destroyStrategyChart failed", e);
      } finally {
        delete this.strategyChartInstances[key];
      }
    },

buildActiveStrategyStepSeries(analysis) {
  const trades = Array.isArray(analysis?.trades) ? analysis.trades : [];
  if (!trades.length) return [];

  const sortedTrades = [...trades].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );

  const firstBuyIndex = sortedTrades.findIndex(
    (t) => String(t?.category).toUpperCase() === "BUY"
  );

  if (firstBuyIndex === -1) return [];

  const usableTrades = sortedTrades
    .slice(firstBuyIndex)
    .filter((t) => {
      const cat = String(t?.category || "").toUpperCase();
      return cat === "BUY" || cat === "SELL";
    });

  if (!usableTrades.length) return [];

  // Start mit bestehender Opening Position
  const openingValue = Number(analysis?.opening_position?.cost_basis || 0);

  let cumulative = openingValue;
  const points = [];

  const firstTs = new Date(usableTrades[0].date).getTime();
  if (Number.isFinite(firstTs)) {
    points.push({
      x: firstTs - 1000,
      y: Math.round(openingValue * 100) / 100,
    });
  }

  for (const t of usableTrades) {
    const cat = String(t.category || "").toUpperCase();
    const ts = new Date(t.date).getTime();

    if (!Number.isFinite(ts)) continue;

    if (cat === "BUY") {
      const buyAmount = Math.abs(Number(t.cash_effect || 0));
      cumulative += buyAmount;
    }

    if (cat === "SELL") {
      const proceeds = Math.abs(Number(t.cash_effect || 0));
      const realizedPnl = Number(t.realized_pnl || 0);

      // Fachlich korrekt: vom investierten Bestand nur den Einstandswert abziehen
      let soldCostBasis = proceeds - realizedPnl;

      if (!Number.isFinite(soldCostBasis)) soldCostBasis = 0;
      if (soldCostBasis < 0) soldCostBasis = 0;

      cumulative -= soldCostBasis;
    }

    // nie unter 0 anzeigen
    cumulative = Math.max(0, cumulative);

    points.push({
      x: ts,
      y: Math.round(cumulative * 100) / 100,
    });
  }

  const apiOpenCostBasis = Number(analysis?.actual_strategy?.open_cost_basis);
  const lastPoint = points[points.length - 1];
  const lastTs = Number(lastPoint?.x);
  const roundedApiOpenCostBasis = Math.round(apiOpenCostBasis * 100) / 100;

  if (
    Number.isFinite(apiOpenCostBasis) &&
    Number.isFinite(lastTs) &&
    Math.abs(Number(lastPoint?.y) - roundedApiOpenCostBasis) > 0.01
  ) {
    points.push({
      x: Math.max(Date.now(), lastTs + 1),
      y: roundedApiOpenCostBasis,
    });
  }

  console.log("strategy points (cost basis)", analysis.stock_name, {
    openingValue,
    apiOpenCostBasis,
    points,
  });

  return points;
},

    getStrategyChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        parsing: false,
        normalized: true,
        interaction: {
          mode: "nearest",
          intersect: false,
        },
        plugins: {
          legend: {
            display: true,
          },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const value = Number(ctx.parsed?.y);
                return `Aktive Strategie: ${new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                  maximumFractionDigits: 2,
                }).format(value)}`;
              },
            },
          },
        },
        scales: {
          x: {
            type: "time",
        time: {
          unit: "day",
          displayFormats: {
            day: "dd.MM.yyyy",
            month: "MM.yyyy",
          },
          tooltipFormat: "dd.MM.yyyy HH:mm",
        },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 8,
              minRotation: 0,
              maxRotation: 0,
            },
            title: {
              display: true,
              text: "Datum",
            },
          },
          y: {
            title: {
              display: true,
              text: "€",
            },
            ticks: {
              callback: (value) =>
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                  maximumFractionDigits: 0,
                }).format(value),
            },
          },
        },
      };
    },

getSynchronizedTimeBounds(pointGroups, forcedBounds = null) {
  const normalizeDailyBounds = (min, max) => {
    if (!this.isDailyMode) {
      return { minX: min, maxX: max };
    }

    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      return { minX: min, maxX: max };
    }

    const minDate = new Date(min);
    const maxDate = new Date(max);

    const minX = Date.UTC(
      minDate.getUTCFullYear(),
      minDate.getUTCMonth(),
      minDate.getUTCDate(),
      0, 0, 0, 0
    );

    const maxX = Date.UTC(
      maxDate.getUTCFullYear(),
      maxDate.getUTCMonth(),
      maxDate.getUTCDate(),
      23, 59, 59, 999
    );

    return { minX, maxX };
  };

  if (forcedBounds?.minX != null && forcedBounds?.maxX != null) {
    return normalizeDailyBounds(forcedBounds.minX, forcedBounds.maxX);
  }

  if (this.synchronizedChartMinX != null && this.synchronizedChartMaxX != null) {
    return normalizeDailyBounds(this.synchronizedChartMinX, this.synchronizedChartMaxX);
  }

  const sharedMin = this.xMin instanceof Date ? this.xMin.getTime() : new Date(this.xMin).getTime();
  const sharedMax = this.xMax instanceof Date ? this.xMax.getTime() : new Date(this.xMax).getTime();

  if (Number.isFinite(sharedMin) && Number.isFinite(sharedMax)) {
    return normalizeDailyBounds(sharedMin, sharedMax);
  }

  const xValues = pointGroups
    .flatMap((points) => (Array.isArray(points) ? points : []))
    .map((point) => Number(point?.x))
    .filter(Number.isFinite);

  if (!xValues.length) {
    return { minX: null, maxX: null };
  }

  return normalizeDailyBounds(
    Math.min(...xValues),
    Math.max(...xValues)
  );
},

getCumulativeSeriesForRange(points, minX, maxX) {
  const series = Array.isArray(points) ? points : [];
  if (!series.length) return [];

  const normalized = series
    .map((point) => ({
      x: point?.x instanceof Date ? point.x.getTime() : Number(point?.x),
      y: Number(point?.y),
    }))
    .filter((point) => Number.isFinite(point.x) && Number.isFinite(point.y))
    .sort((a, b) => a.x - b.x);

  if (!normalized.length) return [];

  if (!Number.isFinite(minX) || !Number.isFinite(maxX)) {
    return normalized.map((point) => ({ x: new Date(point.x), y: point.y }));
  }

  let carryValue = normalized[0].y;
  for (const point of normalized) {
    if (point.x <= minX) carryValue = point.y;
    else break;
  }

  const inRange = normalized.filter((point) => point.x >= minX && point.x <= maxX);
  const result = [];

  if (!inRange.length || inRange[0].x > minX) {
    result.push({ x: new Date(minX), y: carryValue });
  }

  inRange.forEach((point) => {
    if (!result.length || result[result.length - 1].x.getTime() !== point.x) {
      result.push({ x: new Date(point.x), y: point.y });
    }
  });

  if (!result.length) {
    result.push({ x: new Date(minX), y: carryValue });
  }

  console.log("profit/loss day range", {
    minX,
    maxX,
    carryValue,
    sourcePoints: normalized.length,
    inRangePoints: inRange.length,
    resultPoints: result.length,
    firstResultPoint: result[0] || null,
    lastResultPoint: result[result.length - 1] || null,
  });

  return result;
},

getSynchronizedTimeScaleConfig(minX, maxX) {
  const unit = this.isDailyMode ? "day" : "month";

  return {
    type: "time",
    min: minX ?? undefined,
    max: maxX ?? undefined,
    time: {
      unit,
      tooltipFormat: "dd.MM.yyyy HH:mm",
      displayFormats: {
        day: "dd.MM.yyyy",
        month: "MM.yyyy",
      },
    },
    ticks: {
      autoSkip: true,
      maxTicksLimit: 8,
    },
    title: {
      display: true,
      text: "Datum",
    },
  };
},

logChartTimeDebug(label, key, chart, configuredScale = null, extra = {}) {
  console.log(`[chart-time] ${label}`, {
    key,
    isDailyMode: this.isDailyMode,
    synchronizedChartRange: {
      minX: this.synchronizedChartMinX,
      maxX: this.synchronizedChartMaxX,
    },
    xMin: this.xMin,
    xMax: this.xMax,
    configuredScale: configuredScale
      ? {
          min: configuredScale.min ?? null,
          max: configuredScale.max ?? null,
          unit: configuredScale?.time?.unit ?? null,
        }
      : null,
    chartScale: {
      min: chart?.scales?.x?.min ?? null,
      max: chart?.scales?.x?.max ?? null,
    },
    ...extra,
  });
},

renderStrategyCharts(forcedBounds = null) {
  if (!this.showStrategyCharts) {
    Object.keys(this.strategyChartInstances).forEach((key) => {
      this.destroyStrategyChart(key);
    });
    Object.keys(this.profitLossChartInstances).forEach((key) => {
      this.destroyProfitLossChart(key);
    });
    Object.keys(this.netResultChartInstances).forEach((key) => {
      this.destroyNetResultChart(key);
    });
    return;
  }

  const analyses = Array.isArray(this.deltaAnalyses) ? this.deltaAnalyses : [];
  const liveKeys = new Set();

  analyses.forEach((analysis) => {
    const key = analysis.stock_id || analysis.stock_name;
    if (!key) return;

    liveKeys.add(String(key));

    const strategyCanvas = this.strategyChartRefs[key];
    const plCanvas = this.profitLossChartRefs[key];
    const netCanvas = this.netResultChartRefs[key];

    const strategyPoints = this.buildActiveStrategyStepSeries(analysis);
    const plPoints = this.buildProfitLossSeries(analysis);
    const netPoints = this.buildNetResultSeries(analysis);
    const strategyChartData = strategyPoints.map((point) => ({
      x: new Date(Number(point.x)),
      y: Number(point.y),
    }));
    const profitLossChartData = plPoints.map((point) => ({
      x: new Date(Number(point.x)),
      y: Number(point.y),
    }));
    const netResultChartData = netPoints.map((point) => ({
      x: new Date(Number(point.x)),
      y: Number(point.y),
    }));

    this.destroyStrategyChart(key);
    this.destroyProfitLossChart(key);
    this.destroyNetResultChart(key);

    // ---------- Strategie-Chart ----------
    if (strategyCanvas && strategyChartData.length) {
      const ctx = strategyCanvas.getContext("2d");
      if (ctx) {
        const { minX, maxX } = this.getSynchronizedTimeBounds(
          [strategyChartData, profitLossChartData],
          forcedBounds
        );
        const strategyXScale = this.getSynchronizedTimeScaleConfig(minX, maxX);
        const strategyHiddenXScale = {
          ...strategyXScale,
          display: false,
          grid: {
            ...(strategyXScale?.grid || {}),
            display: false,
            drawBorder: false,
            drawTicks: false,
          },
          ticks: {
            ...(strategyXScale?.ticks || {}),
            display: false,
          },
          title: {
            ...(strategyXScale?.title || {}),
            display: false,
          },
        };

        this.strategyChartInstances[key] = markRaw(new Chart(ctx, {
          type: "line",
          data: {
            datasets: [
              {
                label: "Offene Kostenbasis",
                data: strategyChartData,
                parsing: false,
                stepped: "after",
                tension: 0,
                borderWidth: 3,
                pointRadius: 2,
                pointHoverRadius: 3,
                borderColor: "#4caf50",
                backgroundColor: "#4caf50",
                fill: false,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: false,
            normalized: true,
            parsing: false,
            interaction: {
              mode: "nearest",
              intersect: false,
            },
            plugins: {
              legend: {
                display: true,
              },
              tooltip: {
                callbacks: {
                  title: (items) => {
                    const ts = items?.[0]?.parsed?.x;
                    if (!Number.isFinite(ts)) return "";
                    return new Date(ts).toLocaleString("de-DE");
                  },
                  label: (ctx) => {
                    const value = Number(ctx.parsed?.y);
                    return `Offene Kostenbasis: ${new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 2,
                    }).format(value)}`;
                  },
                },
              },
            },
            scales: {
              x: strategyHiddenXScale,
              y: {
                title: {
                  display: true,
                  text: "Offene Kostenbasis (EUR)",
                },
                ticks: {
                  callback: (value) =>
                    new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0,
                    }).format(value),
                },
              },
            },
          },
        }));

        this.logChartTimeDebug("strategy", key, this.strategyChartInstances[key], strategyHiddenXScale, {
          resolvedBounds: { minX, maxX },
          strategyPointsCount: strategyChartData.length,
          plPointsCount: profitLossChartData.length,
          netPointsCount: netResultChartData.length,
        });
      }
    }

    // ---------- Profit/Loss-Chart ----------
    if (plCanvas && profitLossChartData.length) {
      const ctx = plCanvas.getContext("2d");
      if (ctx) {
        const { minX, maxX } = this.getSynchronizedTimeBounds(
          [strategyChartData, profitLossChartData],
          forcedBounds
        );
        const profitLossXScale = this.getSynchronizedTimeScaleConfig(minX, maxX);
        const profitLossSeriesForChart = this.isDailyMode
          ? this.getCumulativeSeriesForRange(profitLossChartData, minX, maxX)
          : profitLossChartData;

        const finalTarget = this.getProfitLossTargetValue(analysis);
        const lastPoint = profitLossSeriesForChart[profitLossSeriesForChart.length - 1];
        const finalValue = Number(lastPoint?.y || 0);

        console.log("profit/loss points", analysis.stock_name, {
          plPoints: profitLossSeriesForChart,
          finalValue,
          finalTarget,
        });

        this.profitLossChartInstances[key] = markRaw(new Chart(ctx, {
          type: "line",
          data: {
            datasets: [
              {
                label: "Profit / Loss kumuliert",
                data: profitLossSeriesForChart,
                parsing: false,
                stepped: "after",
                tension: 0,
                borderWidth: 3,
                pointRadius: 2,
                pointHoverRadius: 3,
                borderColor: "#2196f3",
                backgroundColor: "#2196f3",
                fill: false,
              },
              {
                label: "Break-even",
                data: [
                  { x: new Date(minX), y: 0 },
                  { x: new Date(maxX), y: 0 },
                ],
                parsing: false,
                borderWidth: 1,
                pointRadius: 0,
                borderDash: [6, 6],
                borderColor: "#9e9e9e",
                backgroundColor: "#9e9e9e",
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: false,
            normalized: true,
            parsing: false,
            interaction: {
              mode: "nearest",
              intersect: false,
            },
            plugins: {
              legend: {
                display: true,
              },
              tooltip: {
                callbacks: {
                  title: (items) => {
                    const ts = items?.[0]?.parsed?.x;
                    if (!Number.isFinite(ts)) return "";
                    return new Date(ts).toLocaleString("de-DE");
                  },
                  label: (ctx) => {
                    const value = Number(ctx.parsed?.y);
                    return `${ctx.dataset.label}: ${new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 2,
                    }).format(value)}`;
                  },
                },
              },
            },
            scales: {
              x: profitLossXScale,
              y: {
                title: {
                  display: true,
                  text: "Kumulierter Profit / Loss (€)",
                },
                ticks: {
                  callback: (value) =>
                    new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0,
                    }).format(value),
                },
              },
            },
          },
        }));

        this.logChartTimeDebug("profit-loss", key, this.profitLossChartInstances[key], profitLossXScale, {
          resolvedBounds: { minX, maxX },
          strategyPointsCount: strategyChartData.length,
          plPointsCount: profitLossSeriesForChart.length,
          netPointsCount: netResultChartData.length,
        });
      }
    }

    // ---------- Net-Result-Chart ----------
    if (netCanvas && netResultChartData.length) {
      const ctx = netCanvas.getContext("2d");
      if (ctx) {
        const { minX, maxX } = this.getSynchronizedTimeBounds(
          [strategyChartData, profitLossChartData, netResultChartData],
          forcedBounds
        );
        const netResultXScale = this.getSynchronizedTimeScaleConfig(minX, maxX);
        const netResultSeriesForChart = this.isDailyMode
          ? this.getCumulativeSeriesForRange(netResultChartData, minX, maxX)
          : netResultChartData;

        this.netResultChartInstances[key] = markRaw(new Chart(ctx, {
          type: "line",
          data: {
            datasets: [
              {
                label: "Net Result",
                data: netResultSeriesForChart,
                parsing: false,
                stepped: "after",
                tension: 0,
                borderWidth: 3,
                pointRadius: 2,
                pointHoverRadius: 3,
                borderColor: "#ffb300",
                backgroundColor: "#ffb300",
                fill: false,
              },
              {
                label: "Break-even",
                data: [
                  { x: new Date(minX), y: 0 },
                  { x: new Date(maxX), y: 0 },
                ],
                parsing: false,
                borderWidth: 1,
                pointRadius: 0,
                borderDash: [6, 6],
                borderColor: "#9e9e9e",
                backgroundColor: "#9e9e9e",
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: false,
            normalized: true,
            parsing: false,
            interaction: {
              mode: "nearest",
              intersect: false,
            },
            plugins: {
              legend: {
                display: true,
              },
              tooltip: {
                callbacks: {
                  title: (items) => {
                    const ts = items?.[0]?.parsed?.x;
                    if (!Number.isFinite(ts)) return "";
                    return new Date(ts).toLocaleString("de-DE");
                  },
                  label: (ctx) => {
                    const value = Number(ctx.parsed?.y);
                    return `${ctx.dataset.label}: ${new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 2,
                    }).format(value)}`;
                  },
                },
              },
            },
            scales: {
              x: netResultXScale,
              y: {
                title: {
                  display: true,
                  text: "Net Result (EUR)",
                },
                ticks: {
                  callback: (value) =>
                    new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                      maximumFractionDigits: 0,
                    }).format(value),
                },
              },
            },
          },
        }));

        this.logChartTimeDebug("net-result", key, this.netResultChartInstances[key], netResultXScale, {
          resolvedBounds: { minX, maxX },
          strategyPointsCount: strategyChartData.length,
          plPointsCount: profitLossChartData.length,
          netPointsCount: netResultSeriesForChart.length,
        });
      }
    }
  });

  Object.keys(this.strategyChartInstances).forEach((key) => {
    if (!liveKeys.has(String(key))) {
      this.destroyStrategyChart(key);
    }
  });

  Object.keys(this.profitLossChartInstances).forEach((key) => {
    if (!liveKeys.has(String(key))) {
      this.destroyProfitLossChart(key);
    }
  });

  Object.keys(this.netResultChartInstances).forEach((key) => {
    if (!liveKeys.has(String(key))) {
      this.destroyNetResultChart(key);
    }
  });
},
    handleClickActivty() {
      // implement if needed
    },
  },
};
</script>

<style>
.delta-json {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
}

.raw-data-panel-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.raw-data-copy-btn {
  flex: 0 0 auto;
}

.headline-wrap {
  white-space: normal !important;
  word-break: break-word;
  text-align: left;
}

.analyzer-stock-title {
  cursor: default;
}

.analyzer-stock-title--clickable {
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.layout-wrapper {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  min-height: calc(100vh - 220px);
}

.chart-wrapper {
  flex: 1 1 auto;
  min-width: 0;
}

.strategy-column {
  width: 100%;
}

.strategy-analysis-card {
  width: 100%;
}

.headline-column {
  width: 280px;
  flex: 0 0 auto;
}

.headline-card {
  height: auto;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

.main-chart-card {
  min-height: 0;
}

.main-chart-box {
  position: relative;
  width: 100%;
  height: clamp(240px, 32vh, 340px);
}

.main-chart-card--expanded .main-chart-box {
  height: clamp(420px, 62vh, 720px);
}

.main-chart-canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}

.strategy-chart-box {
  position: relative;
  width: 100%;
  height: clamp(140px, 16vh, 190px);
}

.strategy-chart-box canvas {
  display: block;
  width: 100% !important;
}

@media (max-width: 768px) {
  .layout-wrapper {
    min-height: auto;
  }

  .headline-column {
    display: none;
  }

  .main-chart-box {
    height: 280px;
  }

  .main-chart-card--expanded .main-chart-box {
    height: 340px;
  }

  .strategy-chart-box {
    height: 200px;
  }
}

.actionbar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  min-width: 0;
  padding: 6px 0;
}

.actionbar__controls {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  flex: 0 0 auto;
  -webkit-overflow-scrolling: touch;
}

.actionbar__toolbar {
  width: 100%;
  min-width: 0;
}

/*noinspection CssUnusedSymbol*/
.actionbar__toolbar :deep(.v-toolbar__content) {
  min-width: 0;
}

/*noinspection CssUnusedSymbol*/
.actionbar__toolbar :deep(.v-combobox) {
  min-width: 0;
}

.abtn {
  min-width: 0 !important;
  height: 30px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
  letter-spacing: 0.2px !important;
}

.strategy-chart-box--pl {
  height: clamp(140px, 16vh, 190px);
}

/*noinspection CssUnusedSymbol*/
.abtn.v-btn--icon {
  width: 34px !important;
  height: 34px !important;
  padding: 0 !important;
}

.actionbar__controls::-webkit-scrollbar {
  height: 0;
}

.abtn--percent {
  min-width: 34px !important;
  height: 30px !important;
  padding: 0 8px !important;
  font-size: 13px !important;
  font-weight: 600;
  opacity: 0.7;
  transition: all 0.15s ease;
}

.abtn--active {
  background: #4caf50 !important;
  color: white !important;
  opacity: 1 !important;
  box-shadow: 0 0 0 1px rgba(76,175,80,0.4);
}

.abtn--mode {
  opacity: 0.7;
  font-weight: 600;
  transition: all 0.15s ease;
}

.abtn--mode.abtn--active {
  opacity: 1;
}
</style>
